<template>
  <v-card>
    <v-card-title class="primary accent--text">
      Payment Method
    </v-card-title>

    <v-card-text class="py-7">
      <v-container v-if="!_isEmpty(initCustomer)">
        <v-row>
          <v-col cols="12">
            <customer-payment-source-select
              :customer="initCustomer"
              @change-source="$emit('change-source', $event)"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import CustomerPaymentSourceSelect from "../Common/CustomerPaymentSourceSelect"
import { isEmpty } from 'lodash'

export default {
  components: { CustomerPaymentSourceSelect },
  props: {
    initCustomer: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    _isEmpty: val => isEmpty(val)
  }
}
</script>
